import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import CustomModal from "../Modals/CustomModal";
import CrossIcon from "assets/icons/cross-icon.svg"
import SaveIcon from "assets/icons/Save-icon.svg"
import CustomButton from "shared/components/inputButton";
import CustomForm from "shared/components/CustomForm";
import { CustomDropDown, CustomInput } from "shared/components/allInput";
import CustomOverlay from "shared/components/CustomOverlay";
import { SocialTypeOpts } from "shared/components/DropdownOptions";
import DeleteModal from "shared/Modals/DeleteModal";
import { HandleAdd, handleChange, handleDelete, handlEdit, handleSave } from "utils/TableFunctions";
import formValidation from "utils/validations";

const AddSocialLinkTable = ({
    title,
    allValues,
    setAllValues,
}) => {
    const dispatch = useDispatch();
    const openAction = useRef(null);
    const InputObj = {
        id: "",
        type: "",
        link: "",
    };

    const ignoreInputs = ["status", "id"];
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idToDelete, setIdToDelete] = useState("");

    const onDelete = () => {
        handleDelete(allValues, setAllValues, idToDelete);
        setIdToDelete("");
        setDeleteModal(false);
    };

    const header = (
        <div className="flex justify-content-end flex-wrap">
            <CustomButton
                type="button"
                label="Add"
                onClick={() => HandleAdd(InputObj, allValues, setAllValues)}
            />
        </div>
    );

    const validateLink = (link, type, index) => {
        const updatedArray = [...allValues];
        let errors = updatedArray[index].formErrors
        let linkError = formValidation("link", { type: type, value: link }, updatedArray[index])
        let formErrors = formValidation("type", type, updatedArray[index], ignoreInputs);
        formErrors.link = linkError.link
        updatedArray[index] = { ...updatedArray[index], ["type"]: type, formErrors, };
        setAllValues(updatedArray);
    }

    return (
        <>
            <CustomForm title={title || "Socials"} header={header}>
                <div className="overflow-auto w-full">
                    <table className="financial-table editor-container w-12 mt-3 table-error-align border-1 border-300 w-full border-round-lg">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Link</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody id="" className="cell-width">
                            {allValues?.map((item, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td className={`pl-3 ${item.status === 'save' ? 'p-disabled' : ''}`}>
                                                <CustomDropDown
                                                    data={item}
                                                    name="type"
                                                    options={SocialTypeOpts}
                                                    col={12}
                                                    ignoreLabel
                                                    onChange={({ name, value }) => {
                                                        handleChange(name, value, index, allValues, setAllValues, ["id", "status"])
                                                        validateLink(item.link, value, index, allValues, setAllValues)
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <CustomInput
                                                    data={item}
                                                    col={12}
                                                    onChange={({ name, value }) => handleChange(name, value, index, allValues, setAllValues, ["id", "status"], [""], item?.type)}
                                                    name="link"
                                                    disabled={item?.status === "save" ? true : false}
                                                    ignoreLabel
                                                />
                                            </td>
                                            {item?.status === "save" ? (
                                                <td style={{ "minWidth": "20px" }}>
                                                    <CustomOverlay ref={openAction}>
                                                        <ul className="no-style p-0">
                                                            <li
                                                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                                                onClick={() =>
                                                                    handlEdit(allValues, setAllValues, index)
                                                                }
                                                            >
                                                                <i className="pi pi-file-edit text-dark"></i>
                                                                Edit
                                                            </li>
                                                            <li
                                                                className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                                                onClick={() => {
                                                                    setIdToDelete(index);
                                                                    setDeleteModal(true);
                                                                }}
                                                            >
                                                                <i className="pi pi-trash cursor-pointer text-dark"></i>
                                                                Delete
                                                            </li>
                                                        </ul>
                                                    </CustomOverlay>
                                                </td>
                                            ) : (
                                                <td style={{ "minWidth": "20px" }}>
                                                    <div className="d-flex gap-3">
                                                        <a
                                                            className="cursor-pointer"
                                                            onClick={() =>
                                                                handleSave(
                                                                    index,
                                                                    allValues,
                                                                    setAllValues,
                                                                    ignoreInputs,
                                                                )
                                                            }
                                                        >
                                                            <img src={SaveIcon} />
                                                        </a>
                                                        <a
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                handleDelete(allValues, setAllValues, index);
                                                            }}
                                                        >
                                                            <img src={CrossIcon} />
                                                        </a>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                        <DeleteModal
                                            isOpen={deleteModal}
                                            setIsOpen={setDeleteModal}
                                            onSubmit={onDelete}
                                            loading={loading}
                                            item={"link"}
                                        />
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <br />
            </CustomForm>
        </>
    );
};

export default AddSocialLinkTable;
